
import {
  getReq,
  patchReq,
  postReq,
  deleteReq,
  getById,
  putReq,
  postFormData,
  getBlobReq,
  postStreamReq
} from "../../../services/api";

const state = {
  company: {},
  singleDoc: {},
  documents: [],
  companyDocuments: [],
  dispatchGroups: [],
  chargeAccounts: [],
  payAccounts: [],
  expenseAccounts: [],
  documentSetting: {},
  docTypeItems: [],
  defaultDocType: null,
  tags: [],
  customFields: [],
  assets: [],
  allDocs: [],
  divisions: [],
  allDriverDocs: null,
  rolePermissions: null
};

const getters = {
  company: (state) => state.company,
  documents: (state) => state.documents,
  singleDoc: (state) => state.singleDoc,
  companyDocuments: (state) => state.companyDocuments,
  dispatchGroups: (state) => state.dispatchGroups,
  chargeAccounts: (state) => state.chargeAccounts,
  payAccounts: (state) => state.payAccounts,
  expenseAccounts: (state) => state.expenseAccounts,
  documentSetting: (state) => state.documentSetting,
  tags: (state) => state.tags,
  customFields: (state) => state.customFields,
  assetsData: (state) => state.assets,
  allDocs: (state) => state.allDocs,
  allDriverDocs: (state) => state.allDriverDocs,
  docTypeItems: (state) => state.docTypeItems,
  defaultDocType: (state) => state.defaultDocType,
  divisions: (state) => state.divisions,
  rolePermissions: (state) => state.rolePermissions
};

const actions = {
  async getCompany({ commit }) {
    try {
      const company = await getReq(`app/company/${localStorage.getItem("userSelectedCompany") ? `?company_id=${localStorage.getItem("userSelectedCompany")}` : ''}`);
      commit("setCompany", company);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response;
    }
  },
  async getSingleDoc({ commit }, id) {
    try {
      let document = await getById("app/documents/", id);
      commit("setSingleDoc", document);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async getAllDocuments({ commit }, url) {
    try {
      const data = await getReq(`app/expirydata/${url ? "?" + url : ""}${localStorage.getItem("userSelectedCompany") ? `${url ? '&' : '?'}company_id=${localStorage.getItem("userSelectedCompany")}` : ''}`);
      commit("setDocuments", data.results);
      return { records: data.results, count: data.count, regular_count: data.counts.regular, snoozed_count: data.counts.snoozed, no_notify_count: data.counts.no_notify, required_docs_count: data.counts.required_docs, live_view: data.counts.live_view }
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response;
    }
  },
  async getAllLiveDocuments(_, url) {
    try {
      const data = await getReq(`app/driver-vehicle-live-view/${url ? "?" + url : ""}${localStorage.getItem("userSelectedCompany") ? `${url ? '&' : '?'}company_id=${localStorage.getItem("userSelectedCompany")}` : ''}`);
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response;
    }
  },
  async exportLiveDocumentsData(_, url) {
    try {
      const data = await getReq(`app/driver-vehicle-live-view/export_to_csv/${url ? "?" + url : ""}${localStorage.getItem("userSelectedCompany") ? `${url ? '&' : '?'}company_id=${localStorage.getItem("userSelectedCompany")}` : ''}`);
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async exportExpiryData(_, url) {
    try {
      const data = await getReq(`app/expirydata/export_to_csv/${url ? "?" + url : ""}${localStorage.getItem("userSelectedCompany") ? `${url ? '&' : '?'}company_id=${localStorage.getItem("userSelectedCompany")}` : ''}`);
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async getAllTags({ commit }, id) {
    try {
      const tags = await getReq(`app/add_tags/?company_id=${id}`);
      commit("setTags", tags.sort((a, b) => a.add_tag.toLowerCase().localeCompare(b.add_tag.toLowerCase())));
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

    }
  },
  async getCustomFields({ commit }, model) {
    try {
      const { data } = await getReq(`app/custom-fields/${model ? `?model=${model}` : ''}`);
      const list = Array.isArray(data) ? data : (data.results || []);
      commit("setCustomFields", list);
      return list;
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response && error.response.data ? error.response.data : error;
    }
  },
  async addCustomField(_, payload) {
    try {
      return await postReq(`app/custom-fields/`, payload);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response && error.response.data ? error.response.data : error;
    }
  },
  async updateCustomField(_, { id, payload }) {
    try {
      return await patchReq("app/custom-fields", id, payload);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response && error.response.data ? error.response.data : error;
    }
  },
  async deleteCustomField(_, id) {
    try {
      return await deleteReq("app/custom-fields", id + "/");
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response && error.response.data ? error.response.data : error;
    }
  },
  async getTableViews(_, table) {
    try {
      return await getReq(`app/table-views/${table}/`);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response && error.response.data ? error.response.data : error;
    }
  },
  async addTableView(_, { table, payload }) {
    try {
      return await postReq(`app/table-views/${table}/`, payload);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response && error.response.data ? error.response.data : error;
    }
  },
  async updateTableView(_, { table, id, payload }) {
    try {
      return await patchReq(`app/table-views/${table}`, id, payload);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response && error.response.data ? error.response.data : error;
    }
  },
  async deleteTableView(_, { table, id }) {
    try {
      return await deleteReq(`app/table-views/${table}`, id + "/");
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response && error.response.data ? error.response.data : error;
    }
  },
  async combineSearch(_, search) {
    try {
      const data = await getReq(`app/driver-equipment-combined-search/?search=${search}`);
      return data;
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

    }
  },
  async getAllWebhooks(_, id) {
    try {
      const webhooks = await getReq(`app/notifications/webhooks/?company_id=${id}`);
      return webhooks
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

    }
  },
  async addWebhook(_, payload) {
    try {
      const data = await postReq(`app/notifications/webhooks/`, payload);
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response.data.error ? error.response.data.error : error.response.data;
    }
  },
  async updateWebhook(_, { id, payload }) {
    try {
      return await patchReq("app/notifications/webhooks", id, payload);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response.data.error ? error.response.data.error : error.response.data;
    }
  },
  async deleteWebhook(_, id) {
    try {
      return await deleteReq("app/notifications/webhooks", id);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response.data.error ? error.response.data.error : error.response.data;
    }
  },
  async getAllForms(_, id) {
    try {
      const { data } = await getReq(`app/company-forms/?company_id=${id}`);
      return data.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

    }
  },
  async getAllNotifications(_, id) {
    try {
      const { data } = await getReq(`app/custom-daily-notifications/?company_id=${id}`);
      return data.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

    }
  },
  async getAllDivisions({ commit }) {
    try {
      const { data } = await getReq(`app/division/`);
      commit("setDivisions", data.sort((a, b) => a.division.toLowerCase().localeCompare(b.division.toLowerCase())));
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
    }
  },
  async getLastRecord(_, { company_id, query }) {
    try {
      const { last_record_no } = await getReq(`app/get-last-record-no/?company_id=${company_id}&${query}`);
      return last_record_no
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

    }
  },
  async deleteCompanyForm(_, id) {
    try {
      return await deleteReq("app/company-forms", id);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async deleteCompanyNotification(_, id) {
    try {
      return await deleteReq("app/custom-daily-notifications", id);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async updateCompanyForm(_, { id, payload }) {
    try {
      return await patchReq("app/company-forms", id, payload);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response.data;
    }
  },
  async updateCompanyNotification(_, { id, payload }) {
    try {
      return await patchReq("app/custom-daily-notifications", id, payload);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response.data;
    }
  },
  async deleteCompanyTag(_, id) {
    try {
      return await deleteReq("app/add_tags", id);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response.data;
    }
  },
  async updateCompanyTag(_, { id, payload }) {
    try {
      return await patchReq("app/add_tags", id, payload);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response.data;
    }
  },
  async sendSamsaraCode(_, formData) {
    try {
      await postReq("integration/get_samsara_code/", formData);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async sendMotiveCode(_, formData) {
    try {
      await postReq("integration/get_motive_code/", formData);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async setSamsaraData() {
    try {
      await postReq("integration/data-samsara/", {});
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async setAssetsData(_, link) {
    try {
      await postReq(`integration/${link}/`, {});
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response.data.Error ? error.response.data.Error : error.response.data.error ? error.response.data.error : error.response.data;
    }
  },
  async setIsaacAccessToken(_, payload) {
    try {
      await postReq(`integration/get_isaac_access_token/`, payload);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response.data;
    }
  },
  async getAssetsData({ commit }) {
    try {
      const { data } = await getReq(`integration/asset_view/${localStorage.getItem("userSelectedCompany") ? `?company_id=${localStorage.getItem("userSelectedCompany")}` : ''}`);
      commit("setAssetsData", data);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async getDashboardStats() {
    try {
      const data = await getReq("app/dashboard-stats/");
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async sendCompanyDocuments(_, formData) {
    try {
      const documents = await postReq("app/documents/", formData);
      return documents;
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async sendAIDocs(_, formData) {
    try {
      const documents = await postReq("app/ai-documents/", formData);
      return documents;
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  // The streamed twin of generateAIChat: `onEvent` sees each token / sources /
  // done event as it arrives, so the screen can print the answer while it writes.
  async streamAIChat(_, { payload, onEvent }) {
    try {
      return await postStreamReq("app/ai-documents/chat-stream/", payload, onEvent);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response || error;
    }
  },
  async getAIChatHistory(_, limit) {
    try {
      return await getReq(`app/ai-documents/chat/history/?limit=${limit || 15}`);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response;
    }
  },
  async generateAIChat(_, data) {
    try {
      const chatData = await postReq("app/ai-documents/chat/", data);
      return chatData;
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async suggestDocumentFromAI(_, formData) {
    try {
      const data = await postReq(`app/documents/ai/suggest/?company_id=${localStorage.getItem("userSelectedCompany")}`, formData);
      return data;
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response ? error.response.data : error;
    }
  },
  async retrieveAIDocument(_, id) {
    try {
      return await getById("app/ai-documents/", id);
    } catch (e) {
      if (!e.response) {
        throw "No network connection";
      }
      if (e.response && e.response.status === 500) {
        throw "Internal server error";
      }
      if (e.response && e.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      const errors = e.response.data;
      throw errors;
    }
  },
  async sendBulkCompanyDocuments(_, formData) {
    try {
      const { status } = await postReq("app/bulk-document-async/", formData);
      return status;
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response;
    }
  },
  async loadCompanySampleData(_, payload) {
    try {
      await postReq("app/sync-sample-data/", payload);
      return true
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response;
    }
  },
  async smartDropPlus(_, formData) {
    try {
      const { status } = await postReq("app/document-parser/", formData);
      return status;
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response;
    }
  },
  async checkBulkCompanyDocumentsUploadStatus() {
    try {
      const data = await getReq(`app/bulk-document-async/${localStorage.getItem("userSelectedCompany") ? `?company_id=${localStorage.getItem("userSelectedCompany")}` : ''}`);
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response;
    }
  },
  async updateBulkCompanyDocumentsUploadStatus(_, { id, payload }) {
    try {
      return await patchReq("app/bulk-document-async", id, payload);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async checkSmartDropStatus() {
    try {
      const { lock } = await getReq("app/async-task-lock/");
      return lock
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },

  async updateCompanyDocuments(_, { id, payload }) {
    try {
      return await patchReq("app/documents", id, payload);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async updateAIDocs(_, { id, payload }) {
    try {
      return await patchReq("app/ai-documents", id, payload);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async deleteCompanyDocuments(_, id) {
    try {
      return await deleteReq("app/documents", id);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async deleteAIDocuments(_, id) {
    try {
      return await deleteReq("app/ai-documents", id);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async createCompany(_, { payload, key = null }) {
    try {
      const updatedCompany = await postReq("app/company", payload, key);
      return updatedCompany;
    } catch (e) {
      if (e.response && e.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw e.response.data;
    }
  },
  async updateCompanyID(_, payload) {
    try {
      await postReq("app/update-company-id/", payload);
      return true;
    } catch (e) {
      if (e.response && e.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw e.response.data;
    }
  },
  async updateCompany({ commit }, { id, payload, key = null }) {
    try {
      if (payload instanceof FormData) {
        payload.append("allowed_email_domains", "[]")
      } else if (typeof payload === "object" && payload !== null) {
        payload.allowed_email_domains = []
      }
      const updatedCompany = await patchReq("app/company", id, payload, key);
      commit("setCompany", [updatedCompany]);
      return updatedCompany;
    } catch (e) {
      if (e.response && e.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw e.response.data;
    }
  },

  async addCompanyTag(_, payload) {
    try {
      const { id } = await postReq(`app/add_tags/`, payload);
      return { id }
      // get all team member again
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response.data;
    }
  },
  async addCompanyForm(_, payload) {
    try {
      const { id } = await postReq(`app/company-forms/`, payload);
      return { id }
      // get all team member again
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response.data;
    }
  },
  async addCompanyNotification(_, payload) {
    try {
      const { id } = await postReq(`app/custom-daily-notifications/`, payload);
      return { id }
      // get all team member again
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response.data;
    }
  },
  async addDispatchGroup({ commit }, payload) {
    try {
      const dispatchGroup = await postReq(`app/dispatch-group/`, payload);
      commit("addDispatchGroup", dispatchGroup);
      // get all team member again
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response.data;
    }
  },
  async getDispatchGroups({ commit }, id) {
    try {
      const dispatchGroups = await getReq(
        `app/dispatch-group/?company_id=${id}`
      );
      commit("setDispatchGroup", dispatchGroups);
      // get all team member again
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response.data;
    }
  },

  async deleteDispatchGroup({ commit }, id) {
    try {
      const response = await deleteReq("app/dispatch-group", id + "/");
      commit("deleteDispatchGroup", id);
      return response;
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async updateDispatchGroup({ commit }, payload) {
    try {
      const response = await putReq("app/dispatch-group", payload.id, payload);
      commit("updateDispatchGroup", payload);
      return response;
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },

  async addChargeAccount({ commit }, payload) {
    try {
      const chargeAccount = await postReq(`app/charge-account/`, payload);
      commit("addChargeAccount", chargeAccount);
      // get all team member again
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response.data;
    }
  },
  async getChargeAccounts({ commit }) {
    try {
      const chargeAccounts = await getReq(`app/charge-account/${localStorage.getItem("userSelectedCompany") ? `?company_id=${localStorage.getItem("userSelectedCompany")}` : ''}`);
      commit("setChargeAccount", chargeAccounts);
      // get all team member again
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response.data;
    }
  },

  async deleteChargeAccount({ commit }, id) {
    try {
      const response = await deleteReq("app/charge-account", id + "/");
      commit("deleteChargeAccount", id);
      return response;
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async updateChargeAccount({ commit }, payload) {
    try {
      const response = await putReq("app/charge-account", payload.id, payload);
      commit("updateChargeAccount", payload);
      return response;
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async addPayAccount({ commit }, payload) {
    try {
      const payAccount = await postReq(`app/pay-account/`, payload);
      commit("addPayAccount", payAccount);
      // get all team member again
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response.data;
    }
  },
  async getPayAccounts({ commit }) {
    try {
      const payAccounts = await getReq(`app/pay-account/${localStorage.getItem("userSelectedCompany") ? `?company_id=${localStorage.getItem("userSelectedCompany")}` : ''}`);
      commit("setPayAccount", payAccounts);
      // get all team member again
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response.data;
    }
  },

  async deletePayAccount({ commit }, id) {
    try {
      const response = await deleteReq("app/pay-account", id + "/");
      commit("deletePayAccount", id);
      return response;
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async updatePayAccount({ commit }, payload) {
    try {
      const response = await putReq("app/pay-account", payload.id, payload);
      commit("updatePayAccount", payload);
      return response;
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },

  async addExpenseAccount({ commit }, payload) {
    try {
      const expenseAccount = await postReq(`app/expense-account/`, payload);
      commit("addExpenseAccount", expenseAccount);
      // get all team member again
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response.data;
    }
  },
  async getExpenseAccounts({ commit }) {
    try {
      const expenseAccounts = await getReq(`app/expense-account/${localStorage.getItem("userSelectedCompany") ? `?company_id=${localStorage.getItem("userSelectedCompany")}` : ''}`);
      commit("setExpenseAccount", expenseAccounts);
      // get all team member again
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response.data;
    }
  },

  async deleteExpenseAccount({ commit }, id) {
    try {
      const response = await deleteReq("app/expense-account", id + "/");
      commit("deleteExpenseAccount", id);
      return response;
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async updateExpenseAccount({ commit }, payload) {
    try {
      const response = await putReq("app/expense-account", payload.id, payload);
      commit("updateExpenseAccount", payload);
      return response;
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async getDocumentSettings({ commit }, id) {
    try {
      let documentSetting = await getReq(
        `tms_company/document-settings/?company_id=${id}`
      );
      commit("setDocumentSetting", documentSetting[0]);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async getCompanyDetails(_, payload) {
    try {
      const data = await postReq(`app/get-company-details/`, payload);
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async getSubscriptionDetails(_, company) {
    try {
      const { session_url } = await getReq(`app/stripe-checkout-session/`, company);
      return session_url
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },

  async addUserRole(_, payload) {
    try {
      const data = await postReq(`app/role/`, payload);
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response.data;
    }
  },
  async deleteUserRole(_, id) {
    try {
      return await deleteReq("app/role", id);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async deleteUserReferral(_, id) {
    try {
      return await deleteReq("app/referrals", id);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async getUserRoles() {
    try {
      const { data } = await getReq(`app/role/`);
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async getUserReferrals() {
    try {
      const { data } = await getReq(`app/referrals/`);
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async updateUserRole(_, { id, payload }) {
    try {
      await patchReq("app/role", id, payload);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response;
    }
  },
  async getRoleDetails(_, id) {
    try {
      const data = await getById("app/role/", id);
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async getAllDocs({ commit }, payload) {
    try {
      const documents = await postReq(`app/get_docs/`, payload);
      commit("setAllDocs", documents);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async getUnattachedTaggedDocs() {
    try {
      const { data } = await getReq(`app/unattached-tagged-documents/`);
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async getAIDocs(_, payload) {
    try {
      const data = await getReq(`app/ai-documents/${payload.url ? "?" + payload.url : ""}`);
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async getUserNotes(_, url) {
    try {
      const { data } = await getReq(url);
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async deleteUserNote(_, { url, id }) {
    try {
      return await deleteReq(url, id);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async updateUserNote(_, { url, id, payload }) {
    try {
      await patchReq(url, id, payload);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async createUserNote(_, { url, payload }) {
    try {
      await postReq(url, payload);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async getAllDriverDocs({ commit }, payload) {
    try {
      const documents = await postReq(`app/get_all_docs/`, payload);
      commit("setDriverDocs", documents);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async updateDocumentSettings(_, { payload }) {
    try {
      const response = await putReq(
        `tms_company/document-settings`,
        payload.id,
        payload
      );
      return response;
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async getAllDocTypes({ commit }, url) {
    try {
      const data = await getReq(`app/document-type/${url ? "?" + url : ""}${localStorage.getItem("userSelectedCompany") ? `${url ? '&' : '?'}company_id=${localStorage.getItem("userSelectedCompany")}` : ''}`);
      commit("setDocTypes", data.types.sort((a, b) => a.type.toLowerCase().localeCompare(b.type.toLowerCase())));
      const defaultID = data.types.filter((item) => item.type === 'Default')[0]?.id
      if (defaultID) commit("setDefaultDoc", defaultID)
      return data.types
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async addDocTypeItem(_, payload) {
    try {
      await postReq("app/document-type/", payload);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      const errors = error.response.data;
      const docTypeErrors = [];
      for (const key in errors) {
        if (Object.hasOwnProperty.call(errors, key)) {
          docTypeErrors.push(errors[key]);
        }
      }

      throw docTypeErrors[0][0];
    }
  },
  async deleteDocTypeItem(_, id) {
    try {
      return await deleteReq("app/document-type", id);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response.data;
    }
  },
  async deleteHazmatLoad(_, id) {
    try {
      return await deleteReq("app/loads/hazmat", id);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },

  async deleteJobData(_, id) {
    try {
      return await deleteReq("app/recruiting/job", id);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },

  async addJobData(_, payload) {
    try {
      return await postReq(`app/recruiting/job/`, payload);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async updateJobData(_, payload) {
    try {
      const data = await patchReq(`app/recruiting/job`, payload.id, payload, null, false);
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async addLeadData(_, payload) {
    try {
      return await postReq(`app/recruiting/applicant/`, payload);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async addBulkLead(_, payload) {
    try {
      return await postReq(`app/recruiting/applicant/import/`, payload);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response.data;
    }
  },

  async addTaskData(_, payload) {
    try {
      return await postReq(`app/task/`, payload);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async getAllTasks(_, url) {
    try {
      const data = await getReq(`app/task/${url ? "?" + url : ""}`);
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },

  async deleteTaskData(_, id) {
    try {
      return await deleteReq("app/task", id);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async deleteBulkTasks(_, payload) {
    try {
      return await postReq("app/task/bulk-delete/", payload);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async updateBulkTasks(_, payload) {
    try {
      const response = await patchReq("app/task/bulk-update", null, payload, null, false);
      return response;
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response;
    }
  },
  async updateTaskData(_, { taskId, payload }) {
    try {
      const data = await patchReq(`app/task`, taskId, payload, null, false);
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },


  async getRecruitingData(_, payload) {
    try {
      const data = await getReq(`app/recruiting/${payload.type === 'job' ? 'job' : 'applicant'}/${payload.url ? "?" + payload.url : ""}`);
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response;
    }
  },

  async getRecruitingReport(_, url) {
    try {
      const data = await getReq(`app/recruiting/report/${url ? "?" + url : ""}`);
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response;
    }
  },

  async getExportRecruitingData() {
    try {
      const data = await getReq(`app/recruiting/applicant/export/`);
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async getRecruitingDetails(_, id) {
    try {
      const data = await getById(`app/recruiting/applicant/`, id);
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async deleteRecruitingData(_, id) {
    try {
      return await deleteReq("app/recruiting/applicant", id);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async getHazmatLoads(_, payload) {
    try {
      const data = await getReq(`app/loads/hazmat/${payload.url ? "?" + payload.url : ""}`);
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async getHazmatLoadDetails(_, id) {
    try {
      const data = await getById(`app/loads/hazmat/`, id);
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async addHazmatLoad(_, payload) {
    try {
      const data = await postReq(`app/loads/hazmat/`, payload);
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async updateHazmatLoadDetails(_, { loadId, payload }) {
    try {
      const data = await patchReq(`app/loads/hazmat`, loadId, payload, null, false);
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async updateRecruitingItem(_, { id, payload }) {
    try {
      const data = await patchReq(`app/recruiting/applicant`, id, payload, null, false);
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response.data;
    }
  },
  async addHazmatManifestFiles(_, payload) {
    try {
      const data = await postReq(`app/loads/hazmat/${payload.loadId}/add-manifest/`, payload.formData);
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async deleteManifestFile(_, { loadId, documentID }) {
    try {
      await deleteReq(`app/loads/hazmat/${loadId}/delete-manifest`, documentID);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async getHazmatManifestFiles(_, loadId) {
    try {
      const data = await getReq(`app/loads/hazmat/${loadId}/manifests/`);
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async getHazmatLoadProcessingStatus(_, id) {
    try {
      const data = await getReq(`app/loads/hazmat/${id}/processing-status/`);
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async addDivision(_, payload) {
    try {
      await postReq("app/division/", payload);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      const errors = error.response.data;
      const divisionErrors = [];
      for (const key in errors) {
        if (Object.hasOwnProperty.call(errors, key)) {
          divisionErrors.push(errors[key]);
        }
      }

      throw divisionErrors[0][0];
    }
  },
  async updateDocTypeItem(_, { id, payload }) {
    try {
      await patchReq("app/document-type", id, payload, null, false);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      const errors = error.response.data;
      const docTypeErrors = [];
      for (const key in errors) {
        if (Object.hasOwnProperty.call(errors, key)) {
          docTypeErrors.push(errors[key]);
        }
      }

      throw docTypeErrors[0][0];
    }
  },
  async updateDivision(_, { id, payload }) {
    try {
      await patchReq("app/division", id, payload, null, false);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      const errors = error.response.data;
      const divisionErrors = [];
      for (const key in errors) {
        if (Object.hasOwnProperty.call(errors, key)) {
          divisionErrors.push(errors[key]);
        }
      }

      throw divisionErrors[0][0];
    }
  },
  async bulkUpdateDocTypeItems(_, payload) {
    try {
      await postReq("app/documents-bulk-update-doctype/", payload);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      const errors = error.response.data;
      const docTypeErrors = [];
      for (const key in errors) {
        if (Object.hasOwnProperty.call(errors, key)) {
          docTypeErrors.push(errors[key]);
        }
      }

      throw docTypeErrors[0][0];
    }
  },
  async getAllRequiredDocs(_, url) {
    try {
      const data = await getReq(`app/document-type-report/${url ? "?" + url : ""}${localStorage.getItem("userSelectedCompany") ? `${url ? '&' : '?'}company_id=${localStorage.getItem("userSelectedCompany")}` : ''}`);
      return { records: data.data, total_pages: data.total_pages, queryset_count: data.queryset_count, total_entries: data.total_entries_count, current_page: data.current_page }
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async exportAllRequiredDocsData(_, url) {
    try {
      return await getReq(`app/document-type-report/${url ? "?" + url : ""}${localStorage.getItem("userSelectedCompany") ? `${url ? '&' : '?'}company_id=${localStorage.getItem("userSelectedCompany")}` : ''}`);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async getCompanyActivityLogs(_, url) {
    try {
      const data = await getReq(`app/activity-logs/${url ? "?" + url : ""}${localStorage.getItem("userSelectedCompany") ? `${url ? '&' : '?'}company_id=${localStorage.getItem("userSelectedCompany")}` : ''}`);
      return { records: data.data, total_pages: data.total_pages, queryset_count: data.queryset_count, total_entries: data.total_entries_count, current_page: data.current_page }
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async getCompanyAICreditLogs(_, url) {
    try {
      const data = await getReq(`app/ai-credits/usage/${url ? "?" + url : ""}${localStorage.getItem("userSelectedCompany") ? `${url ? '&' : '?'}company_id=${localStorage.getItem("userSelectedCompany")}` : ''}`);
      return { records: data.data, total_pages: data.total_pages, queryset_count: data.queryset_count, total_entries: data.total_entries_count, current_page: data.current_page }
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async getModelActivityLogs(_, url) {
    try {
      const { data } = await getReq(`app/object-activity-logs/${url ? "?" + url : ""}${localStorage.getItem("userSelectedCompany") ? `${url ? '&' : '?'}company_id=${localStorage.getItem("userSelectedCompany")}` : ''}`);
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async getAllContacts(_, id) {
    try {
      const data = await getReq(`app/company-contacts/?company_id=${id}`);
      return data.contacts.sort((a, b) => a.order_no - b.order_no);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

    }
  },
  async addContact(_, { id, payload }) {
    try {
      const data = await postReq(`app/company-contacts/?company_id=${id}`, payload);
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

    }
  },
  async updateContact(_, { id, payload }) {
    try {
      await patchReq("app/company-contacts", id, payload, null, false);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      const errors = error.response.data;
      const docTypeErrors = [];
      for (const key in errors) {
        if (Object.hasOwnProperty.call(errors, key)) {
          docTypeErrors.push(errors[key]);
        }
      }

      throw docTypeErrors[0][0];
    }
  },
  async deleteContact(_, id) {
    try {
      return await deleteReq("app/company-contacts", id);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async updateContactOrder(_, payload) {
    try {
      await postReq("app/company-contacts-update-order/", payload);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      const errors = error.response.data;
      const docTypeErrors = [];
      for (const key in errors) {
        if (Object.hasOwnProperty.call(errors, key)) {
          docTypeErrors.push(errors[key]);
        }
      }

      throw docTypeErrors[0][0];
    }
  },
  async getRolePermissions({ commit }) {
    try {
      const data = await getReq("app/get-permissions/");
      commit("setRolePermissions", data);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async sendJobApplicationInvite(_, payload) {
    try {
      const data = await postReq(`app/recruiting/invite/`, payload);
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async getRecruitingDocs(_, { id }) {
    try {
      const { data } = await getReq(`app/recruiting/applicant/${id}/documents/`);
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async addRecruitingDoc(_, { id, payload }) {
    try {
      const data = await postReq(`app/recruiting/applicant/${id}/documents/`, payload);
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async updateRecruitingDoc(_, { id, docID, payload }) {
    try {
      const data = await patchReq(`app/recruiting/applicant/${id}/documents/${docID}/`, payload);
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async deleteRecruitingDocument(_, { id, documentID }) {
    try {
      await deleteReq(`app/recruiting/applicant/${id}/documents/${documentID}/`);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async getDPBVaultData(_, payload) {
    try {
      const data = await getReq(`app/vault/records/${payload.url ? "?" + payload.url : ""}`);
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async getDPBVaultDataById(_, id) {
    try {
      const data = await getById(`app/vault/records/`, id);
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async addDPBVaultRecord(_, payload) {
    try {
      const data = await postFormData("app/vault/records/", payload);
      return data;
    } catch (e) {
      if (!e.response) {
        throw "No network connection";
      }
      if (e.response && e.response.status === 500) {
        throw "Internal server error";
      }
      if (e.response && e.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      const errors = e.response.data;
      throw errors;
    }
  },
  async deleteVaultRecord(_, id) {
    try {
      return await deleteReq(`app/vault/records`, id);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async updateVaultDocTypeRecord(_, payload) {
    try {
      return await patchReq(`app/vault/doc-types`, payload.id, payload);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async addVaultDocTypeRecord(_, payload) {
    try {
      return await postReq(`app/vault/doc-types/`, payload);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async deleteVaultDocTypeRecord(_, id) {
    try {
      return await deleteReq(`app/vault/doc-types`, id);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response.data;
    }
  },
  async deleteVaultDocument(_, url) {
    try {
      return await deleteReq(`app/vault/records`, url);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async updateVaultRecord(_, { id, payload }) {
    try {
      const data = await patchReq(`app/vault/records`, id, payload);
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async getDPBVaultDocTypeData(_, payload) {
    try {
      const data = await getReq(`app/vault/doc-types/${payload.url ? "?" + payload.url : ""}`);
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }

      throw error.response;
    }
  },
  async getFormSubmissions(_, url) {
    try {
      return await getReq(`app/forms/submissions/${url ? "?" + url : ""}${localStorage.getItem("userSelectedCompany") ? `${url ? '&' : '?'}company_id=${localStorage.getItem("userSelectedCompany")}` : ''}`);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response && error.response.data ? error.response.data : error;
    }
  },
  async getFormTemplates(_, url) {
    try {
      return await getReq(`app/forms/templates/${url ? "?" + url : ""}${localStorage.getItem("userSelectedCompany") ? `${url ? '&' : '?'}company_id=${localStorage.getItem("userSelectedCompany")}` : ''}`);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response && error.response.data ? error.response.data : error;
    }
  },
  async getUserForms(_, url) {
    try {
      return await getReq(`app/forms/submissions/${url ? "?" + url : ""}${localStorage.getItem("userSelectedCompany") ? `${url ? '&' : '?'}company_id=${localStorage.getItem("userSelectedCompany")}` : ''}`);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response && error.response.data ? error.response.data : error;
    }
  },
  async getFormTemplateOptions(_, url) {
    try {
      return await getReq(`app/forms/templates/options/${url ? "?" + url : ""}${localStorage.getItem("userSelectedCompany") ? `${url ? '&' : '?'}company_id=${localStorage.getItem("userSelectedCompany")}` : ''}`);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response && error.response.data ? error.response.data : error;
    }
  },
  async startFormSubmission(_, payload) {
    try {
      return await postReq(`app/forms/submissions/`, payload);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response && error.response.data ? error.response.data : error;
    }
  },
  async getFormSubmission(_, id) {
    try {
      return await getReq(`app/forms/submissions/${id}/`);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response && error.response.data ? error.response.data : error;
    }
  },
  async updateFormSubmission(_, { id, payload }) {
    try {
      return await patchReq(`app/forms/submissions`, id, payload);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response && error.response.data ? error.response.data : error;
    }
  },
  async submitFormSubmission(_, { id, payload }) {
    try {
      return await postReq(`app/forms/submissions/${id}/submit/`, payload || {});
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response && error.response.data ? error.response.data : error;
    }
  },
  async reviewFormSubmission(_, { id, payload }) {
    try {
      return await postReq(`app/forms/submissions/${id}/review/`, payload);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response && error.response.data ? error.response.data : error;
    }
  },
  async reassignFormSubmission(_, { id, payload }) {
    try {
      return await postReq(`app/forms/submissions/${id}/reassign/`, payload);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response && error.response.data ? error.response.data : error;
    }
  },
  async uploadFormMedia(_, { id, formData }) {
    try {
      return await postFormData(`app/forms/submissions/${id}/media/`, formData);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response && error.response.data ? error.response.data : error;
    }
  },
  async deleteFormSubmission(_, id) {
    try {
      return await deleteReq(`app/forms/submissions`, id + "/");
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response && error.response.data ? error.response.data : error;
    }
  },
  async getFormTemplate(_, id) {
    try {
      return await getReq(`app/forms/templates/${id}/`);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response && error.response.data ? error.response.data : error;
    }
  },
  async addFormTemplate(_, payload) {
    try {
      return await postReq(`app/forms/templates/`, payload);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response && error.response.data ? error.response.data : error;
    }
  },
  async updateFormTemplate(_, { id, payload }) {
    try {
      return await patchReq(`app/forms/templates`, id, payload);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response && error.response.data ? error.response.data : error;
    }
  },
  async assignFormTemplate(_, { id, payload }) {
    try {
      return await postReq(`app/forms/templates/${id}/assign/`, payload);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response && error.response.data ? error.response.data : error;
    }
  },
  async publishFormTemplate(_, id) {
    try {
      return await postReq(`app/forms/templates/${id}/publish/`, {});
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response && error.response.data ? error.response.data : error;
    }
  },
  async unpublishFormTemplate(_, id) {
    try {
      return await postReq(`app/forms/templates/${id}/unpublish/`, {});
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response && error.response.data ? error.response.data : error;
    }
  },
  // One call for the lot: { ids, action } where action is delete, archive,
  // unarchive or due_date (which also carries `due_date`).
  async bulkFormSubmissions(_, payload) {
    try {
      return await postReq(`app/forms/submissions/bulk/`, payload);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response && error.response.data ? error.response.data : error;
    }
  },
  async archiveFormSubmission(_, { id, archived }) {
    try {
      return await postReq(`app/forms/submissions/${id}/archive/`, { archived });
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response && error.response.data ? error.response.data : error;
    }
  },
  async duplicateFormTemplate(_, id) {
    try {
      return await postReq(`app/forms/templates/${id}/duplicate/`, {});
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response && error.response.data ? error.response.data : error;
    }
  },
  async deleteFormTemplate(_, id) {
    try {
      return await deleteReq(`app/forms/templates`, id + "/");
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response && error.response.data ? error.response.data : error;
    }
  },
  async getAllDVIRTemplates(_, url) {
    try {
      const data = await getReq(`app/dvir/templates/${url ? "?" + url : ""}`);
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
    }
  },
  async getDVIRInspection(_, id) {
    try {
      const data = await getReq(`app/dvir/inspections/${id}/`);
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response && error.response.data ? error.response.data : error;
    }
  },
  async updateDVIRInspection(_, { id, payload }) {
    try {
      return await patchReq(`app/dvir/inspections`, id, payload);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response && error.response.data ? error.response.data : error;
    }
  },
  async getDVIRInspectionPDF(_, id) {
    try {
      // Returns the raw axios response so the caller can read the filename off
      // the Content-Disposition header.
      return await getBlobReq(
        `app/dvir/inspections/${id}/pdf/${localStorage.getItem("userSelectedCompany") ? `?company_id=${localStorage.getItem("userSelectedCompany")}` : ""}`
      );
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response && error.response.data ? error.response.data : error;
    }
  },
  async reviewDVIRInspection(_, { id, payload }) {
    try {
      // Manager review step: app/dvir/inspections/{id}/review/
      return await patchReq(`app/dvir/inspections/${id}`, "review", payload);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response && error.response.data ? error.response.data : error;
    }
  },
  async addDVIRInspectionMedia(_, { id, payload }) {
    try {
      return await postFormData(`app/dvir/inspections/${id}/media/`, payload);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response && error.response.data ? error.response.data : error;
    }
  },
  async addDVIRInspection(_, payload) {
    try {
      return await postReq(`app/dvir/inspections/`, payload);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response && error.response.data ? error.response.data : error;
    }
  },
  async getDVIRTemplatesByUnit(_, unitNo) {
    try {
      const data = await getReq(`app/dvir/templates/?unit_id=${encodeURIComponent(unitNo)}`);
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response && error.response.data ? error.response.data : error;
    }
  },
  async getDVIRTemplate(_, id) {
    try {
      const data = await getReq(`app/dvir/templates/${id}/`);
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response && error.response.data ? error.response.data : error;
    }
  },
  async getDVIRCompliance(_, url) {
    try {
      const data = await getReq(`app/dvir/inspections/compliance/${url ? "?" + url : ""}${localStorage.getItem("userSelectedCompany") ? `${url ? '&' : '?'}company_id=${localStorage.getItem("userSelectedCompany")}` : ''}`);
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response && error.response.data ? error.response.data : error;
    }
  },
  async getAllDVIRData(_, url) {
    try {
      const data = await getReq(`app/dvir/inspections/${url ? "?" + url : ""}${localStorage.getItem("userSelectedCompany") ? `${url ? '&' : '?'}company_id=${localStorage.getItem("userSelectedCompany")}` : ''}`);
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
    }
  },
  async addDVIRTemplate(_, payload) {
    try {
      return await postReq(`app/dvir/templates/`, payload);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response && error.response.data ? error.response.data : error;
    }
  },
  async updateDVIRTemplate(_, { id, payload }) {
    try {
      return await patchReq(`app/dvir/templates`, id, payload);
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response && error.response.data ? error.response.data : error;
    }
  },
  async duplicateDVIRTemplate(_, id) {
    try {
      return await postReq(`app/dvir/templates/${id}/duplicate/`, {});
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response && error.response.data ? error.response.data : error;
    }
  },
  async deleteDVIRTemplate(_, id) {
    try {
      return await deleteReq(`app/dvir/templates`, id + "/");
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
      throw error.response.data;
    }
  },
  async getDVIRTemplateStarters() {
    try {
      const data = await getReq(`app/dvir/templates/starters/`);
      return data
    } catch (error) {
      if (error.response && error.response.status === 403) {
        throw "You are not allowed to perform this action.";
      }
    }
  }
};

const mutations = {
  setCompany: (state, company) => (state.company = company),
  setRolePermissions: (state, rolePermissions) => (state.rolePermissions = rolePermissions),
  setDocuments: (state, documents) => (state.documents = documents),
  setTags: (state, tags) =>
  (state.tags = [
    ...new Map(tags.map((item) => [item["add_tag"], item])).values(),
  ]),
  setCompanyDocuments: (state, companyDocuments) =>
    (state.companyDocuments = companyDocuments),
  addDispatchGroup: (state, dispatchGroup) =>
    state.dispatchGroups.push(dispatchGroup),
  setSingleDoc: (state, singleDoc) => state.singleDoc = singleDoc,
  setDispatchGroup: (state, dispatchGroups) =>
    (state.dispatchGroups = dispatchGroups),
  deleteDispatchGroup: (state, id) => {
    const index = state.dispatchGroups.findIndex((x) => x.id === id);
    state.dispatchGroups.splice(index, 1);
  },
  updateDispatchGroup: (state, dispatchGroup) => {
    state.dispatchGroups = state.dispatchGroups.map((item) =>
      item.id === dispatchGroup.id ? dispatchGroup : item
    );
  },
  addChargeAccount: (state, chargeAccount) =>
    state.chargeAccounts.push(chargeAccount),
  setChargeAccount: (state, chargeAccounts) =>
    (state.chargeAccounts = chargeAccounts),
  deleteChargeAccount: (state, id) => {
    const index = state.chargeAccounts.findIndex((x) => x.id === id);
    state.chargeAccounts.splice(index, 1);
  },
  updateChargeAccount: (state, chargeAccount) => {
    state.chargeAccounts = state.chargeAccounts.map((item) =>
      item.id === chargeAccount.id ? chargeAccount : item
    );
  },
  addPayAccount: (state, payAccount) => state.payAccounts.push(payAccount),
  setPayAccount: (state, payAccounts) => (state.payAccounts = payAccounts),
  deletePayAccount: (state, id) => {
    const index = state.payAccounts.findIndex((x) => x.id === id);
    state.payAccounts.splice(index, 1);
  },
  updatePayAccount: (state, payAccount) => {
    state.payAccounts = state.payAccounts.map((item) =>
      item.id === payAccount.id ? payAccount : item
    );
  },
  addExpenseAccount: (state, expenseAccount) =>
    state.expenseAccounts.push(expenseAccount),
  setExpenseAccount: (state, expenseAccounts) =>
    (state.expenseAccounts = expenseAccounts),
  deleteExpenseAccount: (state, id) => {
    const index = state.expenseAccounts.findIndex((x) => x.id === id);
    state.expenseAccounts.splice(index, 1);
  },
  updateExpenseAccount: (state, expenseAccount) => {
    state.expenseAccounts = state.expenseAccounts.map((item) =>
      item.id === expenseAccount.id ? expenseAccount : item
    );
  },
  setDocumentSetting: (state, documentSetting) => {
    state.documentSetting = documentSetting;
  },
  setAssetsData: (state, data) => (state.assets = data),
  setAllDocs: (state, documents) => (state.allDocs = documents),
  setDriverDocs: (state, documents) => (state.allDriverDocs = documents),
  setDocTypes: (state, docTypes) => (state.docTypeItems = docTypes),
  setDefaultDoc: (state, defaultDoc) => (state.defaultDocType = defaultDoc),
  setDivisions: (state, divisions) => (state.divisions = divisions),
  setCustomFields: (state, customFields) => (state.customFields = customFields)
};

export default {
  state,
  getters,
  actions,
  mutations,
};